module.exports = __webpack_public_path__ + "img/utility_parked.884b12c6.svg";